import styled from 'styled-components';

export const StyledPageContainer = styled.div`
  background: ${props =>
    props.theme.themeColors.pageContainer.background} !important;
  display: flex;
  height: 100%;
  transition: background-color ${({ theme }) => theme.backgroundTransitionTime}
    ease;
`;

export const StyledPagesContainer = styled.div`
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
  display: flex;
  height: max-content;
  margin: auto;

  & img {
    pointer-events: none;
  }
`;
